import { createStaticReducer } from '../../../../packages/redux-utils';
import { IFooterLayoutConfiguration } from '../../types/footerLayout';

const defaultState: IFooterLayoutConfiguration | null = null;

export const footerLayoutReducer = createStaticReducer<IFooterLayoutConfiguration | null>(defaultState);
